import { ulid } from 'ulid';
import { Logger, WorkflowContext } from '@samelogic/steps';
import { TriggerConfig, TriggerEventProps } from '../../../models';
import { OnEventTriggeredEvent, TriggerEvent } from '../TriggerEvent';

type TriggerEventState = {
  active: boolean;
  triggerEvent: TriggerEvent;
};

export type OnTriggered = () => void;

/**
 * Trigger Container is used to manage all the conditional logic
 * of the trigger events and fire off the event conditions are met.
 */
export class TriggerManager {
  private readonly triggerEvents = new Map<string, TriggerEventState>();
  /**
   * This trigger is fired
   */
  public onTriggered?: OnTriggered;

  constructor(
    private readonly context: WorkflowContext,
    private readonly logger: Logger,
    readonly configs?: TriggerConfig[]
  ) {
    if (configs) {
      for (const eventConfig of configs) {
        const id = `${ulid()}-${eventConfig.event}`;
        const event = new TriggerEvent(context, eventConfig);
        event.onChanged = (e) => {
          this.handleTriggerEvent(id, e);
        };
        this.triggerEvents.set(id, {
          active: false,
          triggerEvent: event
        });
      }
    }
  }

  public start(): void {
    if (this.triggerEvents.size === 0) {
      return this.onTriggered?.();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    for (const [_id, eventTrigger] of Array.from(this.triggerEvents)) {
      eventTrigger.triggerEvent.start();
    }
  }
  private handleTriggerEvent = (id: string, event: OnEventTriggeredEvent<TriggerEventProps, unknown>) => {
    const triggerEvent = this.triggerEvents.get(id);
    if (triggerEvent) {
      triggerEvent.active = event.condition;
    }

    const activeEvents = Array.from(this.triggerEvents.values()).filter((e) => e.active).length;
    // make sure all events are active
    if (activeEvents === this.triggerEvents.size) {
      this.onTriggered?.();
    }
  };
}
